module.exports = __webpack_public_path__ + "img/ricoh_wechat.d03a33af.png";